<template>
    <div v-show="show.menu">
        <img :src="!isCollapse ? require('../assets/basic/tbyc.png')
                    : require('../assets/basic/tbzk.png')" @click="$store.commit('WATCHER',!isCollapse);isCollapse = !isCollapse;"
             :class="!isCollapse ? 'tbopen' : 'tbclose'" alt=""/>
        <el-aside v-if="isCollapse"  class="wrapper">

            <div  class="menuStt">
                <div v-for="item,index in secondMenus.children" :key="index" @click="handleRoute(item,index)"
                     :class = "secondcheck == index ? 'addclass' : '' " class="cbdh">
                    <img v-if="item.iconpath!=null&&secondcheck == index" :src="require('../assets/basic/'+item.iconpath+'-c.png')" class="iconClass">
                    <img v-else :src="require('../assets/basic/'+item.iconpath+'.png')" class="iconClass"/>
                    {{ item.label }}
                </div>
            </div>
        </el-aside>
    </div>

</template>

<script>

import store from "@/store";

export default {
    data() {
    return {
      isCollapse: this.$store.state.head.isCollapse,
      logoXz: false,
      asideWidth: "5rem",
      btnList: localStorage.getItem("menus") ? JSON.parse(localStorage.getItem("menus")) : [],
        secondMenus:[],
        secondcheck:0,
        show:{
            tb:false,//图标
            menu:true
        },

    };
  },
  methods: {
    handleBtnClick(index,item) {
      this.btnList.forEach((item) => {
        item.hasCheck = false;
      });
      this.btnList[index].hasCheck = true;
      //this.setCheck(index);

        this.$router.push({
            name:item.route,
            params:{
                label:item.label,
                check:index
            }
        })
    },
      handleRoute(item,index){
          this.$store.commit('selectMenu', item);
          this.$router.push({
              name:item.route,
              params:{
                  label:item.label,
                  check:index
              }
          })
         this.secondcheck = index
      },
  },
    mounted(){
        this.secondcheck = this.$store.state.head.secondcheck

        this.btnList[this.$store.state.head.check].hasCheck = true;
        this.secondMenus =  this.btnList[this.$store.state.head.check];
        this.isCollapse = true

        //判断二级菜单是否显示
        if(this.secondMenus.leaf === true && this.secondMenus.level  === 1){
            this.show.menu = false
        }else{
            this.show.menu = true
        }
    },

    watch:{
        $route(){
            this.secondMenus =  this.btnList[this.$store.state.head.check];
            this.secondcheck = this.$store.state.head.secondcheck

            //判断二级菜单是否显示
            if(this.secondMenus.leaf === true && this.secondMenus.level  === 1){
                this.show.menu = false
            }else{
                this.show.menu = true
            }
        },


    }
};
</script>
<style lang="less" >
.wrapper {
  background-color:#fff;
  transition: width 1s;
  height: calc(100% - 20px);
  overflow-x: hidden;
  width: 160px !important;
  margin-top: 10px;
}
.menuStt{
  font-size: 14px;
  color: #323232;
  background-color: #ffffff;
  box-shadow: 3px 0px 4px 0px
  rgba(0, 0, 0, 0.11);
}
.cbdh {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  /*box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);*/
  padding-left: 2rem;
}
.addclass{
  color: #2388C0;
  background-color: #f3ffff;
  height:100%;
}
.iconClass{
  position: relative;
  top: 2px;
  right: 2px;

}
.tbopen{
  position: absolute;top:45%;transform: translate(0, -50%);cursor: pointer;z-index: 12;
}
.tbclose{
  position: absolute;top:45%;transform: translate(160px, -50%);cursor: pointer;z-index: 12;
}
</style>

